import { LinearProgress, Stack } from "@mui/material";
import type { FC } from "react";
import { NotSet } from "../components/not-set";
import { SlackWrapper } from "../components/slack-wrapper/slack-wrapper";
import { useBuiltSlackMessage } from "../hooks/use-built-slack-message";

export const PreviewBodySlackContent: FC = () => {
  const { data, loading } = useBuiltSlackMessage();

  if (loading) return <LinearProgress />;

  return (
    <Stack direction="column" spacing={4} sx={{ padding: 4 }}>
      {data ? (
        <SlackWrapper
          data={data.data}
          context={data.context}
          aliasName={data.alias?.name}
          aliasImage={data.alias?.image}
        />
      ) : (
        <NotSet />
      )}
    </Stack>
  );
};
